/* es-custom v2 2026-10-06: gallerie dei capitoli, barra capitoli, modulo con allegati nel bucket privato dell'OS. */
(function(){
  var root=document.querySelector('.esc'); if(!root||root.dataset.on) return; root.dataset.on='1';

  // gallerie: le miniature cambiano la foto grande e il bollino concept
  root.querySelectorAll('.esc__gal').forEach(function(g){
    var fig=g.querySelector('.esc__fig'), img=fig.querySelector('img');
    g.querySelectorAll('.esc__thumb').forEach(function(b){
      b.addEventListener('click',function(){
        g.querySelectorAll('.esc__thumb').forEach(function(x){x.classList.toggle('is-on',x===b);});
        img.style.opacity=0;
        setTimeout(function(){ img.srcset=b.dataset.srcset; img.src=b.dataset.src; fig.className='esc__fig'+(b.dataset.fit?' '+b.dataset.fit:''); img.style.opacity=1; },180);
      });
    });
  });

  // barra capitoli: evidenzia il capitolo in vista
  var links=[].slice.call(root.querySelectorAll('.esc__nav-l a'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ links.forEach(function(a){ var on=a.getAttribute('href')==='#'+e.target.id; a.classList.toggle('is-on',on); if(on&&a.scrollIntoView&&window.innerWidth<990) a.parentNode.scrollTo({left:a.offsetLeft-16,behavior:'smooth'}); }); } });
    },{rootMargin:'-45% 0px -50% 0px'});
    links.forEach(function(a){ var s=root.querySelector(a.getAttribute('href')); if(s) io.observe(s); });
  }

  var f=root.querySelector('form[data-esc-form]'); if(!f) return;
  var pre=f.querySelector('input[name="aree"][data-k="'+f.dataset.focus+'"]'); if(pre) pre.checked=true;
  var EP=f.dataset.endpoint, MAX=5, MAXB=25*1024*1024;
  var OK=/\.(pdf|jpe?g|png|heic|webp|dwg|dxf|step|stp|igs|iges|stl|3dm|skp|zip|xlsx?|docx?)$/i;
  var input=f.querySelector('[data-files]'), drop=f.querySelector('[data-drop]'), list=f.querySelector('[data-list]');
  var msg=f.querySelector('.esc__msg'), btn=f.querySelector('.esc__send'), lbl=btn.textContent, files=[];
  function say(t,err){ msg.hidden=!t; msg.textContent=t||''; msg.className='esc__msg'+(err?' is-err':''); }
  function mb(b){ return b<1048576 ? Math.max(1,Math.round(b/1024))+' KB' : (b/1048576).toFixed(1).replace('.0','')+' MB'; }
  function draw(){
    list.innerHTML='';
    files.forEach(function(x,i){
      var li=document.createElement('li'); li.className=x.path?'is-up':'';
      li.innerHTML='<span class="n"></span><span class="s"></span><button type="button"></button>';
      li.querySelector('.n').textContent=x.file.name; li.querySelector('.s').textContent=mb(x.file.size);
      var b=li.querySelector('button'); b.textContent=f.dataset.remove;
      b.onclick=function(){ files.splice(i,1); draw(); };
      list.appendChild(li);
    });
  }
  function add(fl){
    say('');
    Array.prototype.forEach.call(fl,function(file){
      if(files.length>=MAX){ say(f.dataset.errMany,true); return; }
      if(!OK.test(file.name)||file.size>MAXB||!file.size){ say(f.dataset.errFile+' '+file.name,true); return; }
      if(files.some(function(x){return x.file.name===file.name&&x.file.size===file.size;})) return;
      files.push({file:file});
    });
    draw(); input.value='';
  }
  input.addEventListener('change',function(){ add(input.files); });
  ['dragenter','dragover'].forEach(function(e){ drop.addEventListener(e,function(ev){ ev.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave','drop'].forEach(function(e){ drop.addEventListener(e,function(ev){ ev.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop',function(ev){ if(ev.dataTransfer) add(ev.dataTransfer.files); });

  // i bottoni dei capitoli spuntano l'area nel modulo
  root.querySelectorAll('[data-area]').forEach(function(a){
    a.addEventListener('click',function(){
      var c=f.querySelector('input[name="aree"][data-k="'+a.dataset.area+'"]'); if(c) c.checked=true;
      setTimeout(function(){ var n=f.querySelector('input[name="nome"]'); if(n) n.focus({preventScroll:true}); },500);
    });
  });

  function post(path,body){
    return fetch(EP+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ return r.json().catch(function(){return {};}).then(function(j){ if(!r.ok) throw new Error(j.errore||''); return j; }); });
  }
  function upload(x){
    if(x.path) return Promise.resolve();
    return post('allegato',{nome:x.file.name,dimensione:x.file.size}).then(function(j){
      return fetch(j.url,{method:'PUT',headers:{'Content-Type':x.file.type||'application/octet-stream'},body:x.file})
        .then(function(r){ if(!r.ok) throw new Error(f.dataset.errFile+' '+x.file.name); x.path=j.percorso; draw(); });
    });
  }
  f.addEventListener('submit',function(e){
    e.preventDefault(); say('');
    if(!f.checkValidity()){ f.reportValidity(); return; }
    btn.disabled=true;
    var seq=Promise.resolve();
    files.forEach(function(x,i){ seq=seq.then(function(){ btn.textContent=f.dataset.uploading+' '+(i+1)+'/'+files.length; return upload(x); }); });
    seq.then(function(){
      btn.textContent=f.dataset.sending;
      var campi={}, aree=[];
      new FormData(f).forEach(function(v,k){
        if(k==='trappola'||k==='consenso') return;
        if(k==='aree'){ aree.push(String(v)); return; }
        if(k==='nda'){ campi.nda='si'; return; }
        campi[k]=String(v).trim();
      });
      if(aree.length) campi.aree=aree.join(', ');
      if(!campi.azienda) campi.azienda=f.dataset.privato; // il backend vuole l'azienda: chi scrive da privato arriva marcato come armatore
      campi.allegati=files.map(function(x){return x.path;});
      return post('invio',{modulo:'custom',campi:campi,lingua:f.dataset.lang,pagina:location.pathname,trappola:f.trappola.value});
    }).then(function(){
      f.classList.add('is-done'); f.querySelector('.esc__done').hidden=false;
      f.scrollIntoView({behavior:'smooth',block:'center'});
      try{(window.dataLayer=window.dataLayer||[]).push({event:'form_submit',form:'custom',files:files.length});}catch(err){}
      try{ if(f.dataset.conv&&window.gtag) window.gtag('event','conversion',{send_to:f.dataset.conv}); }catch(err){}
    }).catch(function(err){
      say((err&&err.message)||f.dataset.err,true); btn.disabled=false; btn.textContent=lbl;
    });
  });
})();
